/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ monthly_price: NonNullable<unknown> }} Subscription_Price_MonthInputs */

const en_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/month`)
};

const ar_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/شهر`)
};

const de_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/Monat`)
};

const es_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/mes`)
};

const fr_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/mois`)
};

const it_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/mese`)
};

const ja_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/月`)
};

const ko_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/월`)
};

const pt_br_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/mês`)
};

const ru_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/месяц`)
};

const th_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/เดือน`)
};

const tr_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/ay`)
};

const zh_cn_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/月`)
};

const zh_tw_subscription_price_month = /** @type {(inputs: Subscription_Price_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.monthly_price}/月`)
};

/**
* | output |
* | --- |
* | "{monthly_price}/month" |
*
* @param {Subscription_Price_MonthInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_price_month = /** @type {((inputs: Subscription_Price_MonthInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Price_MonthInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_price_month(inputs)
	if (locale === "ar") return ar_subscription_price_month(inputs)
	if (locale === "de") return de_subscription_price_month(inputs)
	if (locale === "es") return es_subscription_price_month(inputs)
	if (locale === "fr") return fr_subscription_price_month(inputs)
	if (locale === "it") return it_subscription_price_month(inputs)
	if (locale === "ja") return ja_subscription_price_month(inputs)
	if (locale === "ko") return ko_subscription_price_month(inputs)
	if (locale === "pt_br") return pt_br_subscription_price_month(inputs)
	if (locale === "ru") return ru_subscription_price_month(inputs)
	if (locale === "th") return th_subscription_price_month(inputs)
	if (locale === "tr") return tr_subscription_price_month(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_price_month(inputs)
	return zh_tw_subscription_price_month(inputs)
});